import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { usePromotions, Promotion } from './PromotionsContext';
import { Plus, Ticket, Search, Edit2, Trash2, X, Check } from 'lucide-react';
import { Toggle } from './Toggle';
export function PromotionsPage() {
  const {
    promotions,
    addPromotion,
    updatePromotion,
    deletePromotion
  } = usePromotions();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [search, setSearch] = useState('');
  const [editingId, setEditingId] = useState<string | null>(null);
  const [isAdding, setIsAdding] = useState(false);
  const filteredPromos = promotions.filter(p => p.title.toLowerCase().includes(search.toLowerCase()) || p.code.toLowerCase().includes(search.toLowerCase()));
  return <div className="flex h-screen w-full bg-[#f9fafb] overflow-hidden font-sans flex-col md:flex-row" data-id="element-2818">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} isCollapsed={isSidebarCollapsed} onToggleCollapse={() => setIsSidebarCollapsed(v => !v)} data-id="element-2819" />

      <main className="flex-1 flex flex-col h-full overflow-hidden" data-id="element-2820">
        <div className="px-4 md:px-8 pt-6 md:pt-8 pb-4 flex-shrink-0" data-id="element-2821">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6" data-id="element-2822">
            <div data-id="element-2823">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-2824">Promotions</h1>
              <p className="text-sm text-gray-500 mt-1" data-id="element-2825">
                Manage discount codes and customer offers
              </p>
            </div>
            <button onClick={() => setIsAdding(true)} className="flex items-center gap-2 px-4 py-2.5 bg-orange-500 text-white rounded-xl font-bold text-sm hover:bg-orange-600 transition-colors shadow-sm" data-id="element-2826">
              <Plus size={16} data-id="element-2827" />
              Create Promo
            </button>
          </div>

          <div className="relative max-w-md" data-id="element-2828">
            <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-2829" />
            <input type="text" placeholder="Search by code or title..." value={search} onChange={e => setSearch(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-orange-400 focus:ring-1 focus:ring-orange-400" data-id="element-2830" />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-4 md:px-8 pb-8" data-id="element-2831">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2832">
            {isAdding && <PromoEditorCard onSave={promo => {
            addPromotion(promo);
            setIsAdding(false);
          }} onCancel={() => setIsAdding(false)} data-id="element-2833" />}
            {filteredPromos.map(promo => editingId === promo.id ? <PromoEditorCard key={promo.id} initialPromo={promo} onSave={patch => {
            updatePromotion(promo.id, patch);
            setEditingId(null);
          }} onCancel={() => setEditingId(null)} data-id="element-2834" /> : <div key={promo.id} className={`bg-white rounded-2xl border p-5 shadow-sm flex flex-col ${promo.active ? 'border-gray-200' : 'border-gray-200 opacity-60'}`} data-id="element-2835">
                  <div className="flex items-start justify-between mb-3" data-id="element-2836">
                    <div className="flex items-center gap-2" data-id="element-2837">
                      <div className="w-8 h-8 rounded-lg bg-orange-50 text-orange-600 flex items-center justify-center" data-id="element-2838">
                        <Ticket size={16} data-id="element-2839" />
                      </div>
                      <div data-id="element-2840">
                        <div className="text-sm font-bold text-gray-900" data-id="element-2841">
                          {promo.code}
                        </div>
                        <div className="text-[11px] font-medium text-gray-500 uppercase tracking-wide" data-id="element-2842">
                          {promo.type === 'percent' ? `${promo.value}% OFF` : `ETB ${promo.value} OFF`}
                        </div>
                      </div>
                    </div>
                    <Toggle checked={promo.active} onChange={v => updatePromotion(promo.id, {
                active: v
              })} data-id="element-2843" />
                  </div>

                  <div className="flex-1" data-id="element-2844">
                    <h3 className="text-base font-bold text-gray-900 mb-1" data-id="element-2845">
                      {promo.title}
                    </h3>
                    {promo.description && <p className="text-sm text-gray-500 leading-snug" data-id="element-2846">
                        {promo.description}
                      </p>}
                  </div>

                  <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-2847">
                    <div className="text-xs text-gray-500" data-id="element-2848">
                      {promo.minSubtotal ? `Min. ETB ${promo.minSubtotal}` : 'No minimum'}
                    </div>
                    <div className="flex items-center gap-1" data-id="element-2849">
                      <button onClick={() => setEditingId(promo.id)} className="p-1.5 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2850">
                        <Edit2 size={14} data-id="element-2851" />
                      </button>
                      <button onClick={() => deletePromotion(promo.id)} className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors" data-id="element-2852">
                        <Trash2 size={14} data-id="element-2853" />
                      </button>
                    </div>
                  </div>
                </div>)}
          </div>
        </div>
      </main>
    </div>;
}
function PromoEditorCard({
  initialPromo,
  onSave,
  onCancel
}: {
  initialPromo?: Promotion;
  onSave: (promo: any) => void;
  onCancel: () => void;
}) {
  const [code, setCode] = useState(initialPromo?.code || '');
  const [title, setTitle] = useState(initialPromo?.title || '');
  const [description, setDescription] = useState(initialPromo?.description || '');
  const [type, setType] = useState<'percent' | 'fixed'>(initialPromo?.type || 'percent');
  const [value, setValue] = useState(initialPromo?.value?.toString() || '');
  const [minSubtotal, setMinSubtotal] = useState(initialPromo?.minSubtotal?.toString() || '');
  const handleSave = () => {
    if (!code.trim() || !title.trim() || !value) return;
    onSave({
      code: code.trim().toUpperCase(),
      title: title.trim(),
      description: description.trim() || undefined,
      type,
      value: parseFloat(value),
      minSubtotal: minSubtotal ? parseFloat(minSubtotal) : undefined,
      active: initialPromo ? initialPromo.active : true
    });
  };
  return <div className="bg-white rounded-2xl border border-orange-200 p-5 shadow-md flex flex-col gap-3" data-id="element-2854">
      <div data-id="element-2855">
        <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wide mb-1" data-id="element-2856">
          Promo Code
        </label>
        <input value={code} onChange={e => setCode(e.target.value.toUpperCase())} placeholder="e.g. SUMMER20" className="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm font-bold focus:outline-none focus:border-orange-400 focus:ring-1 focus:ring-orange-400" data-id="element-2857" />
      </div>
      <div data-id="element-2858">
        <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wide mb-1" data-id="element-2859">
          Title
        </label>
        <input value={title} onChange={e => setTitle(e.target.value)} placeholder="e.g. 20% Off Summer Sale" className="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:border-orange-400 focus:ring-1 focus:ring-orange-400" data-id="element-2860" />
      </div>
      <div data-id="element-2861">
        <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wide mb-1" data-id="element-2862">
          Description (Optional)
        </label>
        <input value={description} onChange={e => setDescription(e.target.value)} placeholder="e.g. Valid on all orders over ETB 100" className="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:border-orange-400 focus:ring-1 focus:ring-orange-400" data-id="element-2863" />
      </div>
      <div className="grid grid-cols-2 gap-3" data-id="element-2864">
        <div data-id="element-2865">
          <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wide mb-1" data-id="element-2866">
            Discount Type
          </label>
          <select value={type} onChange={e => setType(e.target.value as any)} className="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:border-orange-400 focus:ring-1 focus:ring-orange-400 bg-white" data-id="element-2867">
            <option value="percent" data-id="element-2868">Percentage (%)</option>
            <option value="fixed" data-id="element-2869">Fixed Amount (ETB)</option>
          </select>
        </div>
        <div data-id="element-2870">
          <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wide mb-1" data-id="element-2871">
            Value
          </label>
          <input type="number" min={0} value={value} onChange={e => setValue(e.target.value)} placeholder={type === 'percent' ? '10' : '50'} className="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:border-orange-400 focus:ring-1 focus:ring-orange-400" data-id="element-2872" />
        </div>
      </div>
      <div data-id="element-2873">
        <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wide mb-1" data-id="element-2874">
          Min. Subtotal (Optional)
        </label>
        <input type="number" min={0} value={minSubtotal} onChange={e => setMinSubtotal(e.target.value)} placeholder="e.g. 100" className="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:border-orange-400 focus:ring-1 focus:ring-orange-400" data-id="element-2875" />
      </div>
      <div className="mt-2 pt-3 border-t border-gray-100 flex items-center justify-end gap-2" data-id="element-2876">
        <button onClick={onCancel} className="px-3 py-1.5 text-sm font-semibold text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2877">
          Cancel
        </button>
        <button onClick={handleSave} disabled={!code.trim() || !title.trim() || !value} className="px-3 py-1.5 text-sm font-bold bg-orange-500 text-white hover:bg-orange-600 rounded-lg transition-colors disabled:opacity-50 flex items-center gap-1" data-id="element-2878">
          <Check size={14} data-id="element-2879" />
          Save
        </button>
      </div>
    </div>;
}